export default "__VITE_ASSET__f788f117__"